<app-title-bar rootBreadCrumbs="['i18n.core.navigation.export-configuration']" titleText="i18n.core.navigation.history"></app-title-bar>
<div class="row">
  <div class="col-4 client-selector">
    <app-client-autocomplete [(selectedClient)]="selectedClient"></app-client-autocomplete>
  </div>
</div>
<div class="row">
  <div class="col">
    <ejs-grid #grid class="grid-with-toolbar grid-no-filter" width="100%" rowHeight="38" [dataSource]="data"
      [allowSorting]="true" [allowPaging]="true" [pageSettings]="pageSettings" [allowFiltering]="true"
      [filterSettings]="filterSettings">
      <e-columns>
        <e-column field="id" [visible]="false" [isPrimaryKey]="true">
        </e-column>
        <e-column field="timestamp"
          headerText="{{'i18n.domain.export-configuration.history.column-headers.timestamp' | translate}}"
          clipMode="EllipsisWithTooltip" width="200px">
          <ng-template #template let-data>
            {{data.timestamp?.toFormat('dd.MM.yyyy HH:mm:ss')}}
          </ng-template>
        </e-column>
        <e-column field="client.Name"
          headerText="{{'i18n.domain.export-configuration.history.column-headers.client' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{data.clientName}} ({{data.clientNumber}})
          </ng-template>
        </e-column>
        <e-column field="configuration.ConfigurationName"
          headerText="{{'i18n.domain.export-configuration.history.column-headers.configuration-name' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{data.configurationName}} ({{data.configurationId}})
          </ng-template>
        </e-column>
        <e-column field="configuration.Type" headerText="{{'i18n.shared.configuration-type' | translate}}"
          clipMode="EllipsisWithTooltip" width="120px">
          <ng-template #template let-data>
            {{getTypeName(data.configurationType) | translate}}
          </ng-template>
        </e-column>
        <e-column field="success"
          headerText="{{'i18n.domain.export-configuration.history.column-headers.success' | translate}}" width="100px"
          [filter]="successFilter">
          <ng-template #template let-data>
            @if(data.success){
              <div class="e-icons icon-checkmark align-middle"></div>
            }
          </ng-template>
        </e-column>
        <e-column field="errorMessage"
          headerText="{{'i18n.domain.export-configuration.history.column-headers.error-message' | translate}}"
          clipMode="EllipsisWithTooltip">
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
